import * as React from 'react';
import { ButtonWrapper, SubmitButton } from '../../atoms/forms/vertical/base';
import { VerticalSelectInput, VerticalStringInput } from '../../../../commonv3/components/atoms/forms/vertical';
import './userForm.module.scss';
import { UserAddressFormState } from '../../../containers/application/states/UserAddressFormState';
import prefectures from './prefectures.json';
import { observer } from 'mobx-react';
import { BodyText } from '@sheinc/shelikes-design-system';

type Props = {
  state: UserAddressFormState;
  submitting: boolean;
  buttonLabel: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: () => any;
};

export const UserAddressForm = observer(({ state, onSubmit, submitting, buttonLabel }: Props) => {
  return (
    <>
      <VerticalStringInput
        id="zipcode"
        size="l"
        label="郵便番号"
        type="text"
        placeholder="0123456"
        state={state.fields.zipcode}
      />
      <VerticalSelectInput
        id="prefecture"
        size="l"
        label="都道府県"
        placeholder={'入力してください'}
        state={state.fields.prefecture}
        options={prefectures.map((p) => ({ value: p.prefName, label: p.prefName }))}
        serializer={(v) => v}
        deserializer={(v) => v}
      />
      <VerticalStringInput
        id="city"
        size="l"
        label="市区町村"
        type="text"
        placeholder="港区"
        state={state.fields.city}
      />
      <VerticalStringInput
        id="address"
        size="l"
        label="番地"
        type="text"
        placeholder="xxx-x"
        state={state.fields.address}
      />
      <VerticalStringInput
        id="building"
        size="l"
        label="建物名"
        type="text"
        placeholder="〇〇ビルディング"
        state={state.fields.building}
      />
      <ButtonWrapper>
        <SubmitButton id="submit-button" loading={submitting} onClick={onSubmit}>
          {buttonLabel}
        </SubmitButton>
      </ButtonWrapper>
    </>
  );
});

export const UserAddressSummary = ({ userAddress }) => {
  return (
    <BodyText>
      〒{userAddress.zipcode} {userAddress.prefecture}
      {userAddress.city}
      {userAddress.address}
      {userAddress.building}
    </BodyText>
  );
};
